// extracted by mini-css-extract-plugin
module.exports = {"form":"login-auth_form__2VIGu","block":"login-auth_block__jyGy_","input":"login-auth_input__2j8AA","button":"login-auth_button__3uhkH"};